import Vue from 'vue'
import Vuex from 'vuex'

// vuex store
import states from './states'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

function initialState () {
  return states
}

// init store
export default new Vuex.Store({
  state: {
    ...states
  },
  mutations: {
    ...mutations,
    reset (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  getters: {
    ...getters
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js